import { createContext, useCallback, useContext, useEffect, useState } from "react";
import { api } from "@/lib/api";
import { setDefaultCurrency } from "@/lib/format";

const AuthCtx = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUserState] = useState(null);
  const setUser = useCallback((u) => {
    setDefaultCurrency(u && u.role === "client" ? u.account_currency : "USD");
    setUserState(u);
  }, []);

  const refreshMe = useCallback(async () => {
    try {
      const { data } = await api.get("/auth/me");
      setUser(data);
    } catch {
      setUser(false);
    }
  }, []);

  useEffect(() => {
    refreshMe();
    const onLogout = () => setUser(false);
    window.addEventListener("tr:logout", onLogout);
    return () => window.removeEventListener("tr:logout", onLogout);
  }, [refreshMe]);

  const login = async (email, password, remember, totp_code) => {
    const { data } = await api.post("/auth/login", { email, password, remember, totp_code: totp_code || null });
    if (data.user) setUser(data.user);
    return data;
  };

  const logout = async () => {
    try { await api.post("/auth/logout"); } catch { /* sessão já encerrada */ }
    setUser(false);
  };

  return <AuthCtx.Provider value={{ user, setUser, login, logout, refreshMe }}>{children}</AuthCtx.Provider>;
}

export const useAuth = () => useContext(AuthCtx);
